// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssVectorOriginSchema = z.enum(['AGENT','STANDARD'] as const);

export type CvssVectorOriginType = `${z.infer<typeof CvssVectorOriginSchema>}`

export default CvssVectorOriginSchema;
